import { createQueryKeys } from '@lukemorales/query-key-factory';

export const masterDataKeys = createQueryKeys('masterDatas', {
  selectCategory: null,
  selectBrand: (filter) => ({
    queryKey: [filter],
  }),
  selectModel: (filter) => ({
    queryKey: [filter],
  }),
  selectColor: null,
  selectLostFoundStatus: null,
  selectNewsChannel: null,
  selectNewsCategory: null,
});
